import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { isPrivatePath } from "@/lib/privatePaths";

// Global safety net: forces <meta name="robots" content="noindex, nofollow">
// on every private/admin/auth route, regardless of auth state or whether the
// rendered branch mounts <Seo>. Public routes are left untouched (managed by Seo).
export default function NoIndexGuard() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (!isPrivatePath(pathname)) return;
    let el = document.querySelector('meta[name="robots"]');
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", "noindex, nofollow");
  }, [pathname]);
  return null;
}
